import { render, staticRenderFns } from "./reisetermine.vue?vue&type=template&id=64067a7e"
import script from "./reisetermine.vue?vue&type=script&lang=js"
export * from "./reisetermine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports